import React, {  useState } from "react";
import AccountTickets from "./AccountTickets";
import AccountPasses from "./AccountPasses";
import { HiOutlineCreditCard, HiOutlineDocument, HiOutlineTicket } from "react-icons/hi";
import AccountDocuments from "./document";
import "./AccountDocPanel.scss";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { useSelector } from "react-redux";
import { State } from "../../store";
import LoadingSpinner from "../../../features/Loading/LoadingSpinner";
import { useTranslation } from "react-i18next";

const AccountDocPanel: React.FC = () => {
  const loading = useSelector((state: State) => state.auth.loading);
  const { t } = useTranslation();
  const [ticketsTabActive, setTicketsTabActive] = useState(0);
  const isDesktop = useDesktopSize();

  return (
    <div className="account-doc-panel">
     
      {loading ? (
        <div className="flex-between-center">
          <LoadingSpinner />
        </div>
      ) : (
        <div className="account-doc-title flex-between-center">
          <button
            onClick={() => setTicketsTabActive(0)}
            className={
              ticketsTabActive === 0
                ? "button big padding-small button-fill-second"
                : "button big padding-small button-text-main"
            }
          >
            <HiOutlineTicket className="icon" />
            {isDesktop ? (
              <React.Fragment>{t("twoje_bilety")}</React.Fragment>
            ) : (
              <React.Fragment>{t("bilety")}</React.Fragment>
            )}
          </button>

          <button
            onClick={() => setTicketsTabActive(1)}
            className={
              ticketsTabActive === 1
                ? "button big padding-small button-fill-second"
                : "button big padding-small button-text-main"
            }
          >
            <HiOutlineCreditCard className="icon" />
            {isDesktop ? (
              <React.Fragment>{t("twoje_karnety")}</React.Fragment>
            ) : (
              <React.Fragment>{t("karnety")}</React.Fragment>
            )}
          </button>
          <button
            onClick={() => setTicketsTabActive(2)}
            className={
              ticketsTabActive === 2
                ? "button big padding-small button-fill-second"
                : "button big padding-small button-text-main"
            }
          >
            <HiOutlineDocument className="icon" />
            {isDesktop ? (
              <React.Fragment>{t("twoje_dokumenty")}</React.Fragment>
            ) : (
              <React.Fragment>{t("dokumenty")}</React.Fragment>
            )}
          </button>
        </div>
      )}

      <div className="account-doc-panel-content">
        {ticketsTabActive === 0 && <AccountTickets />}
        {ticketsTabActive === 1 && <AccountPasses />}
        {ticketsTabActive === 2 && <AccountDocuments />}
      </div>
    </div>
  );
};

export default AccountDocPanel;
